import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';

import {Gestionnaire, ManageRoleService, Page, PageUser} from '../../../common/services';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import {Observable, of} from 'rxjs';
import {catchError, debounceTime, filter, distinctUntilChanged, switchMap, finalize} from 'rxjs/operators';
import {GestionnairesService} from '../../../common/services/individus/gestionnaires.service';
import {PubSubService} from '../../../common/services/pub-sub.service';
import {typeEvents} from '../../../common/enum/type-events';
import {SubSink} from '@Common/core/utils/subsink';

@Component({
  selector: 'p8-bdc-settings-gestionnaires',
  templateUrl: './settings-gestionnaires.component.html',
  styleUrls: ['./settings-gestionnaires.component.scss']
})
export class SettingsGestionnairesComponent implements OnInit, OnDestroy {
  @Input()
  pageUsers: PageUser[] = [];

  @Input()
  page: Page = null;

  GestionnaireControl = new UntypedFormControl();
  gestionnaireSearch: Observable<any[]>;

  searchTerm = '';

  @ViewChild('inputSearch', { static: true }) inputSearch: ElementRef;

  subSink: SubSink = new SubSink();

  withChildren = true;

  constructor(private dialog: MatDialog,
              private manageRoleSvc: ManageRoleService,
              private gestSvc: GestionnairesService,
              private pubsubService: PubSubService
              ) { }

  ngOnInit() {
    this.attachEventSearch();
  }

  onChecked(event: MatSlideToggleChange) {
    console.log(event);
    this.withChildren = event.checked;
  }

  removeGestionnaire(gest) {
    const find = this.pageUsers.findIndex( (g) => {
      return g.id === gest.id;
    });

    if (find > -1) {
      const extra = this._setForceChildren();

      this.pubsubService.publish('loading', true);
      this.subSink.sink = this.gestSvc.delete(gest, 'id', extra)
        .pipe(finalize(() => this.pubsubService.publish('loading', false)))
        .subscribe((d) => {
          this.pageUsers.splice(find, 1);
          this.pubsubService.publish(typeEvents.roleUpdated, 'L\'affectation pour ce gestionnaire a bien été enlevée');
      });
    }
  }

//   affectAllPagesConfirm(gest) {
//     const data = new DialogData();
//     data.title = 'Ajout Gestionnaire à toutes les pages de la rubrique ?';
//     data.message = `Confirmez-vous l'ajout à toutes les pages de cette rubrique
// pour "${gest.user_obj.first_name} ${gest.user_obj.last_name}" ? <br/>Si non, l'habilitation sera uniquement ajoutée qu'à cette page`;
//
//     const dialogRef = this.dialog.open(DialogValidationComponent,{ data: data });
//     dialogRef.updatePosition({top: '40px'});
//     this.subSink.sink = dialogRef.afterClosed().subscribe(result => {
//       this.addSelectedGestionnaire(gest, result);
//     });
//   }

  deleteConfirmGestionnaireDialog(gest) {
    const data = new DialogData();
    const toutes = this.page.numchild > 0 && this.withChildren ? '(cela sera appliqué à toutes les pages de cette page / rubrique)' : '';

    data.title = 'Détachement Gestionnaire';
    data.message = `Confirmez-vous le détachemenent du rôle de gestionnaire pour "${gest.user_obj.first_name} ${gest.user_obj.last_name}" ?
    <br/> Il ne pourra plus éditer cette page ${toutes}`;

    const dialogRef = this.dialog.open(DialogValidationComponent, { data: data });
    dialogRef.updatePosition({top: '40px'});
    this.subSink.sink = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.removeGestionnaire(gest);
      }
    });
  }

  /**
   * Positionnement force_children (en querystring) si l'affectation ou la suppression d'un gestionnaire
   * concerne toutes les pages de la rubrique
   * @private
   */
  _setForceChildren() {
    const extra = new Map<string, string>();
    if (this.withChildren) {
      extra.set('force_children', 'True');
    }

    return extra;
  }

  addSelectedGestionnaire(gest: Gestionnaire, forceChildren = true) {
    console.log(this.page);

    const find = this.pageUsers.find( (g) => {
      return g.user === gest.individu.user;
    });

    if (! find) {
      const pageUser: PageUser = {
        page: this.page.id,
        user: gest.individu.user,
        user_obj: {
          id: gest.individu.user,
          first_name: gest.individu.first_name,
          last_name: gest.individu.last_name
        }
      };

      this.pubsubService.publish('loading', true);
      const extra = this._setForceChildren();
      this.subSink.sink = this.gestSvc.create(pageUser, extra)
        .pipe(finalize(() => this.pubsubService.publish('loading', false)))
        .subscribe((d) => {
          this.pageUsers.push(pageUser);
          this.pubsubService.publish(typeEvents.roleUpdated, 'L\'affectation pour ce gestionnaire a bien été ajoutée');
      });
    }

    this.attachEventSearch();
  }

  attachEventSearch() {
    if (this.inputSearch) {
      this.inputSearch.nativeElement.value = '';
      this.gestionnaireSearch = this.GestionnaireControl.valueChanges
        .pipe(
          debounceTime(250),
          distinctUntilChanged(),
          filter((searchTerm) => searchTerm.length >= 3),
          switchMap(val => {
            return this.gestSvc.searchGestionnaire(val);
          }),
          catchError(err => {
              return of<any[]>([]);
            }
          ));
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
